module.exports = __webpack_public_path__ + "img/SamSquirrel.59b8a11b.png";